// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Float from "@rescript/core/src/Core__Float.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function getOptionString(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.string);
}

function getString(dict, key, $$default) {
  return Core__Option.getOr(getOptionString(dict, key), $$default);
}

function getStringFromJson(json, $$default) {
  return Core__Option.getOr(Core__JSON.Decode.string(json), $$default);
}

function getInt(dict, key, $$default) {
  return Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.float), $$default) | 0;
}

function getOptionInt(dict, key) {
  return Core__Option.map(Core__Option.flatMap(dict[key], Core__JSON.Decode.float), prim => prim | 0);
}

function getOptionFloat(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.float);
}

function getFloatFromString(str, $$default) {
  return Core__Option.getOr(Core__Float.fromString(str), $$default);
}

function getFloatFromJson(json, $$default) {
  let str = Core__JSON.Classify.classify(json);
  if (typeof str !== "object") {
    return $$default;
  }
  switch (str.TAG) {
    case "String" :
      return Core__Option.getOr(Core__Float.fromString(str._0), $$default);
    case "Number" :
      return str._0;
    default:
      return $$default;
  }
}

function getFloat(dict, key, $$default) {
  return Core__Option.getOr(Core__Option.map(dict[key], json => getFloatFromJson(json, $$default)), $$default);
}

function getJsonBoolValue(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonStringFromDict(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonArrayFromDict(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonFromDict(dict, key, $$default) {
  return Core__Option.getOr(dict[key], $$default);
}

function getJsonObjFromDict(dict, key, $$default) {
  return Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.object), $$default);
}

function getDecodedStringFromJson(json, callbackFunc, defaultValue) {
  return Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(json), callbackFunc), Core__JSON.Decode.string), defaultValue);
}

function getDecodedBoolFromJson(json, callbackFunc, defaultValue) {
  return Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(json), callbackFunc), Core__JSON.Decode.bool), defaultValue);
}

function getDictFromObj(dict, key) {
  return Core__Option.getOr(Core__Option.flatMap(dict[key], Core__JSON.Decode.object), {});
}

function getJsonObjectFromDict(dict, key) {
  return Core__Option.getOr(dict[key], {});
}

function getOptionBool(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.bool);
}

function getDictFromJson(json) {
  return Core__Option.getOr(Core__JSON.Decode.object(json), {});
}

function getDictFromDict(dict, key) {
  return getDictFromJson(getJsonObjectFromDict(dict, key));
}

function getValueAtNestedPath(_dict, _keys) {
  while (true) {
    let keys = _keys;
    let dict = _dict;
    let len = keys.length;
    if (len !== 1) {
      if (len === 0) {
        return;
      }
      let innerDict = Core__Option.flatMap(Core__Option.flatMap(keys[0], key => dict[key]), Core__JSON.Decode.object);
      if (innerDict === undefined) {
        return;
      }
      _keys = keys.slice(1);
      _dict = innerDict;
      continue;
    }
    let key = keys[0];
    return dict[key];
  };
}

function getNestedValue(dict, path) {
  return getValueAtNestedPath(dict, path.split("."));
}

function getStringAtPath(dict, path) {
  return Core__Option.flatMap(getNestedValue(dict, path), Core__JSON.Decode.string);
}

function getBool(dict, key, $$default) {
  return Core__Option.getOr(getOptionBool(dict, key), $$default);
}

function getOptionsDict(options) {
  return getDictFromJson(Core__Option.getOr(options, null));
}

function getOptionalArrayFromDict(dict, key) {
  return Core__Option.flatMap(dict[key], Core__JSON.Decode.array);
}

function getArray(dict, key) {
  return Core__Option.getOr(getOptionalArrayFromDict(dict, key), []);
}

function getStrArray(dict, key) {
  return Core__Option.getOr(getOptionalArrayFromDict(dict, key), []).map(json => getStringFromJson(json, ""));
}

function convertDictToArrayOfKeyStringTuples(dict) {
  return Object.entries(dict).map(entries => [
    entries[0],
    Core__Option.getOr(Core__JSON.Decode.string(entries[1]), "")
  ]);
}

function getStringFromOptionalJson(json, $$default) {
  return Core__Option.getOr(Core__Option.flatMap(json, Core__JSON.Decode.string), $$default);
}

function snakeToPascalCase(str) {
  let words = str.split("_");
  return words.filter(item => item.length > 0).map(item => {
    let firstChar = item.charAt(0).toUpperCase();
    let restOfString = item.length > 1 ? item.slice(1) : "";
    return firstChar + restOfString;
  }).join("");
}

function getArrayElement(arr, index, $$default) {
  return Core__Option.getOr(arr[index], $$default);
}

function mergeDict(dict1, dict2) {
  let mergedDict = Object.assign({}, dict1);
  Object.entries(dict2).forEach(param => {
    let value = param[1];
    let key = param[0];
    let match = mergedDict[key];
    if (match !== undefined) {
      let match$1 = Core__JSON.Decode.object(match);
      let match$2 = Core__JSON.Decode.object(value);
      if (match$1 !== undefined) {
        if (match$2 !== undefined) {
          let mergedObj = mergeDict(match$1, match$2);
          mergedDict[key] = mergedObj;
          return;
        }
        mergedDict[key] = value;
        return;
      }
      mergedDict[key] = value;
      return;
    }
    mergedDict[key] = value;
  });
  return mergedDict;
}

function getDisplayName(text) {
  let transformText;
  switch (text) {
    case "afterpay_clearpay" :
      transformText = "Afterpay";
      break;
    case "bnb_smart_chain" :
      transformText = "BNB Smart Chain";
      break;
    case "classic" :
      transformText = "Cash / Voucher";
      break;
    case "credit" :
      transformText = "Card";
      break;
    case "crypto_currency" :
      transformText = "Crypto";
      break;
    case "evoucher" :
      transformText = "E-Voucher";
      break;
    case "ideal" :
      transformText = "iDEAL | Wero";
      break;
    case "open_banking" :
      transformText = "Pay By Bank";
      break;
    case "ach" :
    case "bacs" :
    case "becs" :
    case "sepa" :
      transformText = text + " Debit";
      break;
    default:
      transformText = text;
  }
  let capitalizeWord = str => {
    let firstChar = str[0];
    if (firstChar !== undefined) {
      return firstChar.toUpperCase() + str.slice(1);
    } else {
      return str;
    }
  };
  return transformText.split("_").map(capitalizeWord).join(" ");
}

export {
  getOptionString,
  getString,
  getStringFromJson,
  getInt,
  getOptionInt,
  getOptionFloat,
  getFloatFromString,
  getFloatFromJson,
  getFloat,
  getJsonBoolValue,
  getJsonStringFromDict,
  getJsonArrayFromDict,
  getJsonFromDict,
  getJsonObjFromDict,
  getDecodedStringFromJson,
  getDecodedBoolFromJson,
  getDictFromObj,
  getJsonObjectFromDict,
  getOptionBool,
  getDictFromJson,
  getDictFromDict,
  getValueAtNestedPath,
  getNestedValue,
  getStringAtPath,
  getBool,
  getOptionsDict,
  getOptionalArrayFromDict,
  getArray,
  getStrArray,
  convertDictToArrayOfKeyStringTuples,
  getStringFromOptionalJson,
  snakeToPascalCase,
  getArrayElement,
  mergeDict,
  getDisplayName,
}
/* No side effect */
